<div class="main-page">
  <div class="container">
    <div class="access-denied">
      <p>Store not found.</p>
      <img src="assets/images/cards/not-found.png" />
    </div>
  </div>
</div>
